export default "__VITE_ASSET__b7415b25__"